import {VariantConfigT} from '@/lib/types/colors.types';

export const lightConfig: VariantConfigT = {
  basic: {
    icon: 'light',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'light',
    active: 'light',
  },
  outline: {
    icon: 'light',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'light',
    iconHover: 'light',
    iconActive: 'light',
    hover: 'light',
    active: 'light',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
